module.exports = __webpack_public_path__ + "static/img/logo-black.b544e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-black.png
// module id = mxas
// module chunks = 2